module.exports = __webpack_public_path__ + "static/media/avatar.5f92255b.png";